"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeConsumablePriceCommand = void 0;
const ddd_library_1 = require("@hoepel.app/ddd-library");
const types_1 = require("@hoepel.app/types");
class ChangeConsumablePriceCommand extends ddd_library_1.CommandBase {
    constructor() {
        super(...arguments);
        this.name = 'change-consumable-price-command';
    }
    static create(consumableName, priceCents, metadata) {
        if (priceCents < 0) {
            throw new Error('Cannot create price with negative cents');
        }
        if (Math.round(priceCents) !== priceCents) {
            throw new Error('Price in cents should be an integer');
        }
        return new ChangeConsumablePriceCommand({ consumableName, priceCents }, metadata);
    }
    get price() {
        return types_1.Price.fromCents(this.payload.priceCents);
    }
    get consumableName() {
        return this.payload.consumableName;
    }
}
exports.ChangeConsumablePriceCommand = ChangeConsumablePriceCommand;
//# sourceMappingURL=change-consumable-price.command.js.map